// SCSS removed — all styles now flow through tailwind.css (Tailwind utilities +
// the ported theme partials + forms/schedule/bf-compat), so @apply resolves.
import './styles/tailwind.css';

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singlePost from './routes/single/singlePost';
import pageTemplateTemplateFlexible from './routes/pageTemplateTemplateFlexible';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  singlePost,
  pageTemplateTemplateFlexible,
});

/** Load Events */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => routes.loadEvents());
} else {
  routes.loadEvents();
}
